import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms'
import { DeviceType } from './devicetype';
import { DeviceTypeService } from '../../services/devicetype.service';
import { ApiResponse } from '../../admin/apiresponse';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'devicetype',
    template: require('./admin.devicetype.add.component.html'),
    providers: [DeviceTypeService]
})

export class DeviceTypeAddComponent implements OnInit {

    public deviceForm: FormGroup; 
    public submitted: boolean; 
    public apiResponse: ApiResponse;
    public createDeviceTypeSubscription: Subscription;
    public testGroupFilterModes: string[];
    public versionSelectionModes: string[];
    public urlExpirationValues: string[];

    constructor(private fb: FormBuilder, private devicetypeService: DeviceTypeService) {
    }
    
    ngOnInit() {
        this.initiliazeValues();
        this.buildForm();
    }

    buildForm(): void {
        this.deviceForm = this.fb.group({
            name: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(50)])],
            description: ['', Validators.compose([Validators.required, Validators.maxLength(1000)])],
            issystemtype: [false],
            createsystemtype: [false],
            versionselectionmode: [''],
            testgroupfiltermode: [''],
            urlExpirationTime: ['']
        });
    }

    initiliazeValues() {
        this.devicetypeService.getVersionSelectionModes()
            .subscribe(
            success => {
                this.versionSelectionModes = success.data;
                (<FormControl>this.deviceForm.controls['versionselectionmode'])
                    .setValue(this.versionSelectionModes[0], { onlySelf: true });
            },
                error => this.handleError(<any>error)
            );
        this.devicetypeService.getTestGroupFilterModes()
            .subscribe(
            success => {
                this.testGroupFilterModes = success.data;
                (<FormControl>this.deviceForm.controls['testgroupfiltermode'])
                    .setValue(this.testGroupFilterModes[0], { onlySelf: true });
            },
            error => this.handleError(<any>error)
            );

        this.devicetypeService.getUrlExpirationValues()
            .subscribe(
            success => {
                this.urlExpirationValues = success.data;
                (<FormControl>this.deviceForm.controls['urlExpirationTime'])
                    .setValue(this.urlExpirationValues[0], { onlySelf: true });
            },
            error => this.handleError(<any>error)
            );
    }

    createDevicetype(deviceType: DeviceType) {
        this.submitted = true;     
        
        this.createDeviceTypeSubscription = this.devicetypeService.createDeviceType(deviceType)
            .subscribe(
            success => this.setCreateResponse(success),
            error => this.handleError(<any>error)
            );
    }
    
    setCreateResponse(resp: ApiResponse) {
        this.apiResponse = resp;
        this.submitted = false;
    }
    
    private handleError(resp: ApiResponse) {
        console.log(resp);
    }
}




// WEBPACK FOOTER //
// ./app/admin/devicetype/admin.devicetype.add.component.ts